<template>
  <div class="medtronic-lobbying-chart">
    <div class="graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
      <h3 class="chart-hed" v-if="showHeading">Medtronic spends millions each year on lobbying in the US</h3>
      <p v-if="showDeck">The company’s formidable lobbying and legal teams have pushed for deregulation and won high-profile court cases.</p>
      <column-chart :chart-height-ratio="baseHeightRatio" :chart-data="chartData" :chart-options="chartOptions"></column-chart>
      <p class="chart-source">Source: <a href="https://www.opensecrets.org/lobby/clientsum.php?id=D000022110">Center for Responsive Politics</a></p>
    </div>
  </div>
</template>

<script>
  import chartData from '../assets/medtronic-lobbying.json'
  import ColumnChart from '@/components/ColumnChart.vue'
  import embeddable from '../mixins/embeddable'

  export default {
    name: 'MedtronicLobbyingChart',
    mixins: [embeddable],
    components: {
      ColumnChart,
    },
    data() {
      return {
        chartData,
        chartOptions: {
          chartName: "medtronicLobbying",
          seriesName: "amount",
          labelWidth: 35,
          barColor: "#3B98AB",
          xAxisTickFormat: this.xAxisYearFormat,
          yAxisTickFormat: function(d) {return d === 0 ? d : "$" + d/1000000 + "m";},
          yAxisTicks: 5,
        }
      }
    }
  }
</script>
